export default "__VITE_ASSET__BJ0M87Pz__";